import styled from "styled-components";
export const LabelContainer = styled.div.withConfig({
  displayName: "data-labelstyles__LabelContainer",
  componentId: "sc-xfhgjx-0"
})(["", " >:first-child{", "}"], {
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-end"
}, {
  marginRight: "0.5rem",
  fontWeight: "300"
});
